module.exports = __webpack_public_path__ + "img/55-l.63e1ba10.png";